import React, { useEffect, useRef, useState } from 'react';
import { CustomTooltip, ICustomTooltipProps, useDeviceType, Outside } from '@cian/ui-kit';

import { IconFunctionalHelpCircle16 } from '../../Icons/IconFunctionalHelpCircle16';
import * as s from './LabelTooltip.css';

type ILabelTooltip = Pick<ICustomTooltipProps, 'content'>;

/**
 * Тултип для лэйбла
 */
export const LabelTooltip = ({ content }: ILabelTooltip) => {
  const iconRef = useRef<HTMLDivElement>(null);
  const [isOpened, setIsOpened] = useState(false);
  const isPhone = useDeviceType() === 'phone';

  useEffect(() => {
    setIsOpened(false);
  }, [isPhone]);

  return (
    <>
      <Outside active={isPhone && isOpened} onOutside={() => setIsOpened(false)}>
        <div
          ref={iconRef}
          className={s['icon-wrapper']}
          onMouseEnter={!isPhone ? () => setIsOpened(true) : undefined}
          onMouseLeave={!isPhone ? () => setIsOpened(false) : undefined}
          onClick={
            isPhone
              ? e => {
                  e.preventDefault();
                  setIsOpened(isOpened => !isOpened);
                }
              : undefined
          }
        >
          <IconFunctionalHelpCircle16 />
        </div>
      </Outside>

      <CustomTooltip
        content={content}
        anchorRef={iconRef}
        flip
        maxWidth={190}
        open={isOpened}
        placement="left-start"
        portal
        preventOverflow
        size="S"
        onClose={() => {}}
        theme={'white'}
      />
    </>
  );
};
